var table_viewer_default = {
  "viewMode": "ew1AI",
  "editMode": "B-mLn",
  "container": "Q0RQj",
  "cell": "fiJsF"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
